import apiFetch from '../apiFetch'

export default function (token) {
  return apiFetch({ endPoint: 'Document/TypesRestricted', method: 'GET', token: token })
}
